import { styled } from '@nykaa/ui-components';
import ScrollToElement from 'shared/components/ScrollToElementById';

export const ReviewSummaryContainer = styled.div<{ disableCursor: boolean }>`
  display: flex;
  align-items: center;
  margin: ${({ theme }) => `${theme.spacing.spacing40} 0 ${theme.spacing.spacing40} 0`};
  border:1px solid ${({ theme }) => theme.colors.textOutline};
  ${({ disableCursor }) =>
    disableCursor
      ? `cursor: default;`
      : `cursor: pointer;
  `}
`;

export const RatingWrapper = styled.div`
  display: flex;
  padding: ${({ theme }) => `${theme.spacing.spacing20} ${theme.spacing.spacing40}`};
  border-right: 1px solid ${({ theme }) => theme.colors.textOutline};
  border-radius: ${({ theme }) => theme.borders.radius10};
`;

export const RatingCount = styled.div`
  padding-right: ${({ theme }) => theme.spacing.spacing20};
  ${({ theme }) => theme.typography.titleSmall};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const BasedOnLight = styled.div`
  padding: 0 ${({ theme }) => theme.spacing.spacing60};
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const ScrollToElementById = styled(ScrollToElement)`
  display: block;
  width: fit-content;
`;
